(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-image"] && !Shopify.designMode) return;
  try {
    // Handle lazy loading with fade-in effect
  document.addEventListener('DOMContentLoaded', function() {
    const lazyImages = document.querySelectorAll('.responsive-image img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          // If image is already loaded, show it immediately
          if (img.complete) {
            img.classList.add('loaded');
          } else {
            // Otherwise wait for load event
            img.addEventListener('load', function() {
              img.classList.add('loaded');
            });
            
            // Fallback: if load event doesn't fire, show after a delay
            setTimeout(() => {
              if (!img.classList.contains('loaded')) {
                img.classList.add('loaded');
              }
            }, 1000);
          }
          
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-height-calculator"] && !Shopify.designMode) return;
  try {
    (function() {
    var CACHE_PREFIX = 'headerHeight_';
    var ROW1_CACHE_PREFIX = 'headerRow1_';
    var RESIZE_DEBOUNCE_MS = 100;

    function cacheKey() {
      return CACHE_PREFIX + window.innerWidth + 'x' + window.innerHeight;
    }
    function row1CacheKey() {
      return ROW1_CACHE_PREFIX + window.innerWidth + 'x' + window.innerHeight;
    }

    function getTransparentSections() {
      return document.querySelectorAll('.section-transparent');
    }

    function measureHeight() {
      var siteHeader = document.querySelector('.site-header');
      return siteHeader ? siteHeader.offsetHeight : 0;
    }

    function measureRow1Height() {
      var section = document.querySelector('.site-header-sticky-navigation');
      if (!section) return 0;
      // Pick the first *visible* row-2 (mobile vs desktop each has its own .row-2-wrapper;
      var row2s = section.querySelectorAll('.row-2-wrapper');
      var row2 = null;
      for (var i = 0; i < row2s.length; i++) {
        if (row2s[i].offsetHeight > 0) {
          row2 = row2s[i];
          break;
        }
      }
      if (!row2) return 0;
      var sectionTop = section.getBoundingClientRect().top + window.scrollY;
      var row2Top = row2.getBoundingClientRect().top + window.scrollY;
      return Math.max(0, Math.round(row2Top - sectionTop));
    }

    function applyOffset(heightValue, showSections) {
      document.documentElement.style.setProperty('--margin-top-header', heightValue);
      var pxMatch = /^-(\d+)px$/.exec(heightValue);
      document.documentElement.style.setProperty('--header-height', (pxMatch ? pxMatch[1] : '0') + 'px');
      if (showSections) {
        getTransparentSections().forEach(function(section) {
          section.classList.add('header-offset-ready');
        });
      }
    }

    function applyStickyNavTop(px) {
      if (px > 0) {
        document.documentElement.style.setProperty('--header-sticky-nav-top', '-' + px + 'px');
      } else {
        document.documentElement.style.setProperty('--header-sticky-nav-top', '0px');
      }
    }

    function recalculate(saveToCache, showSections) {
      var h = measureHeight();
      if (h) {
        var heightValue = '-' + h + 'px';
        applyOffset(heightValue, showSections);
        if (saveToCache !== false) {
          try { sessionStorage.setItem(cacheKey(), heightValue); } catch (e) {}
        }
      } else {
        document.documentElement.style.setProperty('--header-height', '0px');
      }
      var row1H = measureRow1Height();
      if (row1H > 0) {
        applyStickyNavTop(row1H);
        if (saveToCache !== false) try { sessionStorage.setItem(row1CacheKey(), String(row1H)); } catch (e) {}
      } else {
        applyStickyNavTop(0);
        if (saveToCache !== false) try { sessionStorage.removeItem(row1CacheKey()); } catch (e) {}
      }
    }

    function onResize() {
      recalculate(true, false);
    }

    document.addEventListener('DOMContentLoaded', function() {
      var key = cacheKey();
      var transparentSections = getTransparentSections();
      var cached;
      try { cached = sessionStorage.getItem(key); } catch (e) {}

      if (cached) {
        applyOffset(cached, true);
        var cachedRow1;
        try { cachedRow1 = sessionStorage.getItem(row1CacheKey()); } catch (e) {}
        if (cachedRow1 !== null && cachedRow1 !== '') applyStickyNavTop(parseInt(cachedRow1, 10));
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { recalculate(true, false); });
        });
      } else {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { recalculate(true, true); });
        });
      }

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(onResize, RESIZE_DEBOUNCE_MS);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
